import axios from "./index";

class PermissionsApi {
  static fetchGroups = () => {
    return axios.get(`/groups/`);
  };

  static fetchPermissions = (groupId) => {
    return axios.get(`/permissions/${groupId}/group_permissions/`);
  };

  static savePermissions = (groupId, permissions) => {
    return axios.post(`/permissions/${groupId}/update_permissions/`, {
      permissions,
    });
  };
}

export default PermissionsApi;
